export default __webpack_public_path__ + "static/media/es-ml.f56747d8.svg";